// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w8ztIuAqobxoDaVE3VQL {

    display: inline-flex;

    align-items: center;

    gap: 0.375rem;

    font-family: Noto Sans;

    font-size: 17px;

    font-weight: 700;

    --tw-text-opacity: 1;

    color: rgb(47 47 47 / var(--tw-text-opacity, 1))
}

._PpoxwE7IdPj4Wbhf7jI {

    height: 14;

    width: 15px;

    font-family: Noto Sans;

    font-weight: 600;

    --tw-text-opacity: 1;

    color: rgb(0 0 0 / var(--tw-text-opacity, 1))
}

.VDpiqFMyxKdJka87ZJTF {

    height: 12px
}

.QbWS60vSRuQwSd4tDERr {

    cursor: pointer
}
.gjYauW72bSYEO3ISzTcp {

    cursor: default
}
`, "",{"version":3,"sources":["webpack://./src/components/common/Breadcrumb/breadcrumb.module.css"],"names":[],"mappings":"AACE;;IAAA,oBAAsF;;IAAtF,mBAAsF;;IAAtF,aAAsF;;IAAtF,sBAAsF;;IAAtF,eAAsF;;IAAtF,gBAAsF;;IAAtF,oBAAsF;;IAAtF;AAAsF;;AAItF;;IAAA,UAAoD;;IAApD,WAAoD;;IAApD,sBAAoD;;IAApD,gBAAoD;;IAApD,oBAAoD;;IAApD;AAAoD;;AAIpD;;IAAA;AAAe;;AAIf;;IAAA;AAAqB;AAGrB;;IAAA;AAAqB","sourcesContent":[".breadcrumb_text {\n  @apply text-gray-500 font-inter font-bold inline-flex items-center gap-1.5 text-[17px];\n}\n\n.customLeftArrow {\n  @apply text-black w-[15px] h-[14] font-h1 font-inter;\n}\n\n.back_button {\n  @apply h-[12px];\n}\n\n.pointer {\n  @apply cursor-pointer;\n}\n.default {\n  @apply cursor-default;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breadcrumb_text": `w8ztIuAqobxoDaVE3VQL`,
	"customLeftArrow": `_PpoxwE7IdPj4Wbhf7jI`,
	"back_button": `VDpiqFMyxKdJka87ZJTF`,
	"pointer": `QbWS60vSRuQwSd4tDERr`,
	"default": `gjYauW72bSYEO3ISzTcp`
};
export default ___CSS_LOADER_EXPORT___;
